import React, { useState } from "react";
import { Box, Container, Text, VStack } from "@chakra-ui/react";
import NavBar from "../../../Components/Navbar/NavBar";
import SalesLAC from "./SalesLAC";
import ReportsLAC from "./ReportsLAC";
import lac_logo from "../../../Assets/lac_logo.png";
import axios from "axios";

const LAC = () => {
  const [selectedOption, setSelectedOption] = useState("Sales");
  
  const handleTabClick = async (tab) => {
    setSelectedOption(tab);
    const resJWTTableau = await axios.get(
      `${process.env.REACT_APP_BACKEND_API_URL}/generatejwt`,
      { withCredentials: true }
    );
    localStorage.setItem("tableauToken", resJWTTableau.data);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <SalesLAC content="Sales LAC" color="red" />;
      case "Reports":
        return <ReportsLAC content="Reports LAC" />;
      default:
        return <SalesLAC content="Sales LAC" color="red" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar 
        tabIndicatorColor="red.500" 
        logo={lac_logo} 
        onTabClick={handleTabClick} 
      />
      
      <Box bg="white" w="100%" h="calc(100vh - 60px)" overflow="hidden">
        {renderContent()}
      </Box>
    </Box>
  );
};

export default LAC;
